import { ImThemeProviderZenith } from '@im/im-theme';
import { MuiProviders } from '@im/ui-lib/theme/MuiProviders';
import { Dialog } from '@im/ui-lib/zenith/Dialog';
import React, { useState } from 'react';
import { CustomerBillingSelector } from './internal/CustomerBillingSelector';
import { BillingHeaderContextTo } from 'mf_core/provider/billing-header/billing-header-context';
import { useBillingHeaderProvider } from 'mf_core/provider';
import { useTranslate } from '@im/react-localization';

type Props = {
  popoverOpen: boolean;
  resellerType: string;
  setPopoverOpen: (value: boolean) => void;
};

export function ResellerBillingSelector(props: Props) {
  const { popoverOpen, resellerType, setPopoverOpen } = props;
  const translate = useTranslate();
  const { billingHeader, modifyBillingHeader } = useBillingHeaderProvider();
  const [selectedAddress, setSelectedAddress] = useState<any>({});

  const setAddress = (address: any) => {
    setSelectedAddress(address);
  };

  const primaryOnClick = (selectedAddress: any) => {
    setPopoverOpen(false);

    const newObj: BillingHeaderContextTo = {
      billingAddress: [selectedAddress],
      cnpjNumber: selectedAddress?.taxExemptNumber,
      hasIE: selectedAddress?.hasIe,
      resellerId: selectedAddress?.resellerNumber,
      resellerType: resellerType,
      selectedMode: 'customer',
      shipToProvince: selectedAddress?.city,
      shipToUF: selectedAddress?.state,
    };
    modifyBillingHeader(newObj);
  };

  return (
    <>
      <ImThemeProviderZenith>
        <MuiProviders>
          <Dialog
            backgroundBlur
            backgroundType="gradient"
            dialogFooterType="horizontal-fill-container"
            dialogHeaderSupportingText={translate(
              'BillingHeader.IdentifyEndUser'
            )}
            dialogHeaderText={translate(
              'BillingHeader.WhoAreYouShoppingForToday'
            )}
            dialogHeaderType="stack-left-aligned"
            headerDivider={false}
            helpIcon={false}
            minHeight="300px"
            onPrimaryButtonClick={() => primaryOnClick(selectedAddress)}
            open={popoverOpen}
            padding
            primaryButtonProps={{
              disabled: !selectedAddress?.taxExemptNumber,
              sx: { width: '100%' },
            }}
            primaryButtonText={translate('BillingHeader.Confirm')}
            secondaryButtonText=""
            showCloseButton={false}
            showDialogFooter
            type="stack-left-aligned"
          >
            <CustomerBillingSelector
              selectedAddress={billingHeader?.billingAddress?.[0]}
              setSelectedAddress={setAddress}
            />
          </Dialog>
        </MuiProviders>
      </ImThemeProviderZenith>
    </>
  );
}
